import React, { useState, useEffect } from 'react';
import { Select } from 'antd';
import countries from 'country-region-data';

interface IProps {
    onChange?: any;
    value?: any;
}

const SelectCountries: React.FC<IProps> = props => {
    const [value, setValue] = useState<any>(props.value || {});

    useEffect(() => {
        setValue(props.value);
    }, [props]);

    const onChangeSelect = (value: string) => {
        const { onChange } = props;

        if (!('value' in props)) {
            setValue(value);
        }

        if (onChange) {
            onChange(value);
        }
    };

    return (
        <Select
            showSearch
            labelInValue
            optionFilterProp="children"
            onChange={onChangeSelect}
            value={value}
            size="large"
        >
            {countries.map(row => {
                return (
                    <Select.Option key={row.countryShortCode} value={row.countryShortCode}>
                        {row.countryName}
                    </Select.Option>
                );
            })}
        </Select>
    );
};

export default SelectCountries;
